module.exports = __webpack_public_path__ + "static/media/7H.ad3ad861.svg";